import { render, staticRenderFns } from "./groupDiscussion.vue?vue&type=template&id=49523c2a&scoped=true&"
import script from "./groupDiscussion.vue?vue&type=script&lang=js&"
export * from "./groupDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49523c2a",
  null
  
)

export default component.exports